module.exports = __webpack_public_path__ + "static/media/säng-min.08c7cd46.png";